/**
 * Utility to generate a list of IUrl objects representing the category hub
 * entry for a given product path and provider. Returns at most one URL.
 */
import IUrl from '@/interfaces/IUrl';
import Provider from '@/enums/Provider';
import UrlTypes from '@/enums/UrlTypes';
import UrlFetchStatus from '@/enums/UrlFetchStatus';
import { patterns } from './patterns';
import { ICategoryHubPattern } from '@/interfaces/ICategoryHubPattern';

/**
 * Find the first pattern matching the provider & product path,
 * and map it to an IUrl object.
 * @param provider - provider enum to filter patterns
 * @param productPath - the product page path to test against
 * @returns Array with a single IUrl entry if matched, or empty array
 */
export function getCategoryHubUrls(
    provider: Provider,
    productPath: string
): IUrl[] {
    const match = patterns.find((p: ICategoryHubPattern) =>
        p.provider === provider && p.test(productPath)
    );
    if (!match) return [];
    return [{
        pathname: match.hubPathname,
        urlType: UrlTypes.CATEGORY_HUB,
        isSitemap: false,
        fetchStatus: UrlFetchStatus.TO_FETCH,
    }];
}
